import { useEffect } from "react";

import styles from "./style.module.scss";

type PrintDocumentHeaderProps = {
  title: string,
  subtitle?: string,
  fecha: string,
}

const PrintDocumentHeader = (props: PrintDocumentHeaderProps) => {
  const { title, subtitle, fecha } = props;

  useEffect(() => {
  }, []);

  return (
    <>
      <div className="titulo">
        <div className="tipo">
          {title}
        </div>
        <div className="fecha">
          {fecha}
        </div>
      </div>
      {subtitle && (
        <div className={styles.subtitle}>
          {subtitle}
        </div>
      )}
    </>
  );
}

export default PrintDocumentHeader
  ;
